module.exports = __webpack_public_path__ + "static/media/README.786d63c4.md";